import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  APPOINTMENT_PATH,
  APPOINTMENT_REGISTRATION_PATH,
  APPOINTMENT_REGISTRATION_QUEUE_JOURNEY_PATH,
  APPOINTMENT_REGISTRATION_QUEUE_STATUS_AND_JOURNEY_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const MobileRegistrationPage = lazy(() => import('./pages/MobileRegistrationPage/MobileRegistrationPage'));
const QueueStatusAndJourneyPage = lazy(() => import('./pages/QueueStatusAndJourneyPage/QueueStatusAndJourneyPage'));

export const MOBILE_REGISTRATION_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <MobileRegistrationPage />,
    displayTitle: () => 'Registration',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_REGISTRATION_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: APPOINTMENT_PATH,
    component: () => <QueueStatusAndJourneyPage />,
    displayTitle: () => 'Queue Status And Journey',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_REGISTRATION_QUEUE_JOURNEY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <QueueStatusAndJourneyPage />,
    displayTitle: () => 'Queue Status And Journey',
    pageType: PageType.PRIVATE,
    path: APPOINTMENT_REGISTRATION_QUEUE_STATUS_AND_JOURNEY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
